class ScrollAnimate extends HTMLElement {
    constructor() {
        super()
        this.throttleDelay = 20

        this.style.setProperty('--delay', `${this.throttleDelay}ms`)
        this.style.setProperty('--scroll', this.offset())
        this.style.setProperty('--width', this.clientWidth)
        this.style.setProperty('--height', this.clientHeight)

        this.throttledScroll = this.throttle(this.scroll.bind(this), this.throttleDelay)
    }

    connectedCallback() {
        this.observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        this.isVisible = true
                        this.checkOnce()
                    }
                }
            },
            { root: null, rootMargin: '0px', threshold: 0 },
        )
        this.observer.observe(this)
        window.addEventListener('scroll', this.throttledScroll)
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledScroll)
        this.observer.unobserve(this)
    }

    scroll() {
        if (this.isVisible) {
            this.checkOnce()
            this.style.setProperty('--scroll', this.offset())
        }
    }

    offset() {
        let value
        const rect = this.getBoundingClientRect(),
            scrollTop = Math.round(window.scrollY),
            docHeight = document.documentElement.offsetHeight,
            viewHeight = document.documentElement.clientHeight,
            elViewTop = Math.round(rect.top),
            elHeight = rect.height

        const elTopMargin = Math.min(scrollTop + elViewTop, viewHeight)
        const elBottomMargin = Math.min(docHeight - (scrollTop + elViewTop + elHeight), viewHeight)
        const min = -1 * elTopMargin
        const max = elHeight + elBottomMargin
        const top = -1 * elViewTop

        if (top >= max) {
            value = 1
        } else if (top <= min) {
            value = 0
        } else {
            value = this.normalize(top, min, max - viewHeight)
        }
        value = value * 100
        value = Math.round((value + Number.EPSILON) * 100) / 100
        // if (this.id == 'scroll-1') {
        //     console.log({
        //         id: this.id,
        //         // scrollTop,
        //         elTopMargin,
        //         elBottomMargin,
        //         min,
        //         max,
        //         range,
        //         elViewTop,
        //         top,
        //         value,
        //     })
        // }
        return value
    }

    checkOnce() {
        if (!this.dataset.once) {
            this.dataset.once = true
        }
    }

    normalize(value, min, max) {
        return (value - min) / (max - min)
    }

    throttle(func, delay) {
        let timer = null
        return () => {
            const _this = this
            const args = []
            for (let _len = arguments.length, _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key]
            }
            if (timer === null) {
                timer = setTimeout(() => {
                    func.apply(_this, args)
                    timer = null
                }, delay)
            }
        }
    }
}

customElements.define('scroll-animate', ScrollAnimate)
